import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol viewBox=\"0 0 15 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-refresh\"><path d=\"M14 8.5a.5.5 0 1 1 1 0 7.5 7.5 0 1 1-3.44-6.307L12.61.799a.5.5 0 0 1 .88.162l1.158 4.002a.5.5 0 0 1-.481.64L10 5.592a.5.5 0 0 1-.398-.801l1.355-1.798A6.5 6.5 0 1 0 14 8.5z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol